import { render, staticRenderFns } from "./form-cultura.vue?vue&type=template&id=bc1f269e&"
import script from "./form-cultura.vue?vue&type=script&lang=js&"
export * from "./form-cultura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports